import React, { useEffect, useState } from 'react'
import { FormattedMessage, FormattedRelativeTime } from 'react-intl'

import { styled } from '@mui/material/styles'
import messages from './TimeStatus.messages'

export interface IOwnProps {
    className?: string
    time: Date
    pickupX?: number
}

export type IProps = IOwnProps

const TimeStatus: React.FC<IProps> = (props) => {
    const { className, time, pickupX } = props
    const [showTimer, setShowTimer] = useState(true)
    // console.log('pickupX', pickupX)

    const timeValue = () => time.getTime() / 1000 - Date.now() / 1000

    useEffect(() => {
        const interval = setInterval(() => {
            setShowTimer(
                !!pickupX && timeValue() > 0 && timeValue() / 60 > pickupX
            )
        }, 1000)
        return () => clearInterval(interval)
    }, [time, pickupX])

    const timeValueRes = timeValue()

    console.log('showTimer', showTimer, time, pickupX)

    return showTimer ? (
        <></>
    ) : (
        <span className={className}>
            {timeValueRes > 0 ? (
                <>
                    <FormattedMessage {...messages.ends} />&nbsp;
                    <FormattedRelativeTime
                        value={timeValueRes}
                        numeric='auto'
                        updateIntervalInSeconds={1}
                    />
                </>
            ) : (
                <FormattedMessage {...messages.cycleEnded} />
            )}
        </span>
    )
}

export default styled(TimeStatus)(({ theme }) => ({
    fontSize: 12,
    fontWeight: 400,
    color: theme.palette.error.main,
}))
